var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.75,
    cy: 27.5,
    r: 25.875,
    stroke: "white",
    strokeWidth: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 29.4688H33.6562L34.9688 24.2188H30.375V21.5938C30.375 20.2419 30.375 18.9688 33 18.9688H34.9688V14.5588C34.5409 14.5023 32.9252 14.375 31.2189 14.375C27.6555 14.375 25.125 16.5498 25.125 20.5437V24.2188H21.1875V29.4688H25.125V40.625H30.375V29.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b2f4d79273703f16d31c90c3ec9dcdfb.svg";
export { ForwardRef as ReactComponent };